import ROUTES from "../routes";

const components = {
  emisor: [
    {
      component: 'Solicitudes',
      url: ROUTES.SOLICITUDES,
      title: '',
      icon: '',
    },
    {
      component: 'DetalleSolicitud',
      url: ROUTES.DETALLE_SOLICITUD,
      title: '',
      icon: '',
    }
  ],
  asesor: [
    {
      component: 'Solicitudes',
      url: ROUTES.SOLICITUDES,
      title: '',
      icon: '',
    },
    {
      component: 'DetalleSolicitud',
      url: ROUTES.DETALLE_SOLICITUD,
      title: '',
      icon: '',
    },
    {
      component: 'SupervisorSolicitudSubir',
      url: ROUTES.SUPERVISOR_SOLICITUD_SUBIR,
      title: '',
      icon: '',
    }
  ],
  supervisor: [
    {
      component: 'Distribucion',
      url: ROUTES.SUPERVISOR_DISTRIBUCION,
      title: '',
      icon: '',
    },
    {
      component: 'SupervisorSolicitud',
      url: ROUTES.SUPERVISOR_SOLICITUD,
      title: '',
      icon: '',
    },
    {
      component: 'SupervisorDetalleSolicitud',
      url: ROUTES.SUPERVISOR_SOLICITUD_DETALLE,
      title: '',
      icon: '',
    },
    {
      component: 'EjecutivoCobranzaAutorizacion',
      url: ROUTES.EJEC_COBRANZA_AUTORIZACION,
      title: '',
      icon: ''
    },
    {
      component: 'EjecutivoCobranzaAutorizacionDetalle',
      url: ROUTES.EJEC_COBRANZA_AUTORIZACION_DETALLE,
      title: '',
      icon: ''
    },
    {
      component: 'EjecutivoSuscripcionConsulta',
      url: ROUTES.CONSULTA_ORDENES_SUSCRIPCION,
      title: '',
      icon: ''
    },
    {
      component: 'SupervisorSolicitudSubir',
      url: ROUTES.SUPERVISOR_SOLICITUD_SUBIR,
      title: '',
      icon: '',
    }
  ],
  consulta: [
    {
      component: 'SupervisorSolicitud',
      url: ROUTES.SUPERVISOR_SOLICITUD,
      title: '',
      icon: '',
    },
    {
      component: 'SupervisorDetalleSolicitud',
      url: ROUTES.SUPERVISOR_SOLICITUD_DETALLE,
      title: '',
      icon: '',
    }
  ],
  ejecutivoCobranza: [
    {
      component: 'EjecutivoCobranzaAutorizacion',
      url: ROUTES.EJEC_COBRANZA_AUTORIZACION,
      title: '',
      icon: ''
    },
    {
      component: 'EjecutivoCobranzaAutorizacionDetalle',
      url: ROUTES.EJEC_COBRANZA_AUTORIZACION_DETALLE,
      title: '',
      icon: ''
    }
  ],
  supervisorAgencia: [
    {
      component: 'SupervisorSolicitud',
      url: ROUTES.SUPERVISOR_SOLICITUD,
      title: '',
      icon: '',
    },
    {
      component: 'SupervisorDetalleSolicitud',
      url: ROUTES.SUPERVISOR_SOLICITUD_DETALLE,
      title: '',
      icon: '',
    },
    {
      component: 'SupervisorSolicitudSubir',
      url: ROUTES.SUPERVISOR_SOLICITUD_SUBIR,
      title: '',
      icon: '',
    }
  ],
  ejecutivoSuscriptorJefe: [
    {
      component: 'EjecutivoSuscripcionConsulta',
      url: ROUTES.CONSULTA_ORDENES_SUSCRIPCION,
      title: '',
      icon: ''
    }
  ],
  ejecutivoSuscriptorAnalista: [
    {
      component: 'EjecutivoSuscripcionConsulta',
      url: ROUTES.CONSULTA_ORDENES_SUSCRIPCION,
      title: '',
      icon: ''
    }
  ],
  ejecutivoSuscriptorMedico: [
    {
      component: 'EjecutivoSuscripcionConsulta',
      url: ROUTES.CONSULTA_ORDENES_SUSCRIPCION,
      title: '',
      icon: ''
    }
  ]
}

const rolesConfig: any = [
  {
    rol: process.env.REACT_APP_ROL_EMISOR,
    routes: components.emisor
  },
  {
    rol: process.env.REACT_APP_ROL_ASESOR,
    routes: components.asesor
  },
  {
    rol: process.env.REACT_APP_ROL_SUPERVISOR,
    routes: components.supervisor
  },
  {
    rol: process.env.REACT_APP_ROL_CONSULTAS,
    routes: components.consulta
  },
  {
    rol: process.env.REACT_APP_ROL_COBRANZA,
    routes: components.ejecutivoCobranza
  },
  {
    rol: process.env.REACT_APP_ROL_SUPERVISOR_AGENCIA,
    routes: components.supervisorAgencia
  },
  {
    rol: process.env.REACT_APP_ROL_SUSCRIPTOR_JEFE,
    routes: components.ejecutivoSuscriptorJefe
  },
  {
    rol: process.env.REACT_APP_ROL_SUSCRIPTOR_ANALISTA,
    routes: components.ejecutivoSuscriptorAnalista
  },
  {
    rol: process.env.REACT_APP_ROL_SUSCRIPTOR_MEDICO,
    routes: components.ejecutivoSuscriptorMedico
  },
  
];

export { rolesConfig };
